import { render, staticRenderFns } from "./upgradeSetting.vue?vue&type=template&id=346b9290&scoped=true&"
import script from "./upgradeSetting.vue?vue&type=script&lang=js&"
export * from "./upgradeSetting.vue?vue&type=script&lang=js&"
import style0 from "./upgradeSetting.vue?vue&type=style&index=0&id=346b9290&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346b9290",
  null
  
)

export default component.exports